import React from 'react'

import style from './css/course.module.css'

const semester1 = ['Programming Principles and Techniques', 'Logic Building and Elementary Programming', 'AI Driven Dynamic Website Development', 'Intelligent UI/UX With AI Insights', 'Building Intelligent Interfaces with React', 'eProject - AI Powered Website Development', 'Innovate with Generative AI', 'Data Management with SQL Server']

const semester2 = ['Data Processing with XML and JSON', 'AI Driven Java Programming', 'Building Rich Java Applications with JavaFX and AI Tools', 'Foundation of AI', 'Rapid App Development Using Low-Code and No-Code Approach', 'Project - Smart Solutions using Java', 'Smart C# Programming with AI Assistance', 'AI Integrated Distributed Version Control Systems', 'Emerging Job Areas (SMAC)']

const semester3A = ['GenAI Launchpad - Accelerator Program for Future Innovators', 'Dynamic AI Driven Java Web Components', 'AI Augmented Applications with Spring and Spring Boot', 'Intelligent App Crafting with Dart', 'AI powered Flutter and Dart Apps', 'Intelligent DevOps - Agile with AI','eProject - AI-Enhanced Cross-Platform App Development']

const semester3B = ['GenAI Launchpad - Accelerator Program for Future Innovators', 'Building AI-Driven Solutions with ASP.NET Core MVC', 'Intelligent App Crafting with Dart', 'AI powered Flutter and Dart Apps', 'Intelligent DevOps - Agile with AI','eProject - AI-Enhanced Cross-Platform App Development']

const semester4A = ['AI-Enhanced  Working with MySQL', 'Next-Gen Programming with Python and AI', 'AI-Powered Web Engineering with Django', 'eProject - Python Power Building Dynamic Solutions', 'Next-Gen Enterprise Apps - Building Intelligent and Scalable Solutions', 'Intelligent Web Services - Jakarta EE and AI-Enhanced APIs', 'Deployment System and Containerize with Docker and Kubernetes', 'Software Project Management']

const semester4B = ['AI-Enhanced  Working with MySQL', 'Next-Gen Programming with Python and AI', 'AI-Powered Web Engineering with Django', 'eProject - Python Power Building Dynamic Solutions', 'eProject - Python Power Building Dynamic Solutions', 'AI - Driven Application Development with Microsoft Azure', 'Generative AI for .NET Developers with Google AI', 'Deployment System and Containerize with Docker and Kubernetes', 'Software Project Management']

const semester4C = ['AI-Enhanced  Working with MySQL', 'Next-Gen Programming with Python and AI', 'AI-Powered Web Engineering with Django', 'eProject - Python Power Building Dynamic Solutions', 'Oracle Database SQL', 'Program with PL/SQL', 'Oracle Database Administration I', 'Oracle Database Administration II']

const semester4D = ['Technologies of Computer Network', 'Implementing and Administering Network Solutions', 'Cybersecurity Operations Fundamentals', 'Microsoft Azure Fundamentals', 'Administering AI-Powered Applications on Azure', 'Azure Architect Design', 'AI-Enhanced Ethical Hacking', 'Project - Azure Administration']

const semester4E = ['Mathematical Insights into Data and Inference', 'Real-World AI Solutions with Applied Python Programming', 'AI and ML with Python', 'Applied Machine Learning with Python', 'Applied AI for Natural Language Processing (NLP)','Deep Learning using Neural Networks', 'Fundamentals of Computer Vision', 'AI Nexus Architecture and Agents', 'Capstone Project - Recommendation Engine and Customer Churn Prediction']

const semester4F = ['Scalable Data Systems with MongoDB and AI Integration', 'Data Analytics & Visualization with Power BI for AI Insights', 'Real-World AI Solutions with Applied Python Programming', 'AI-Powered Data Science Methodologies  with Python', 'Advanced AI Techniques with Machine Learning and Deep Learning', 'Reinforcement  Learning with Data Science', 'Introduction to Data Lakes', 'Designing Efficient Deep Learning Systems', 'MLOps - Model Lifecycle and Deployment', 'Capstone Project - AI-Powered Data-Driven Decision Intelligence']

const semester4G = ['Next-Gen Programming  with Python and AI', 'AI-Powered IoT - Intelligence at the Edge', 'Smart Networks for IOT', 'AI-Driven IoT Programming with Python', 'Advanced IoT Systems', 'Capstone Project for IoT']

const Course = () => {

  return (
    <section className={style.courseContainer}>
    {/* Semester 1 */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 1</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester1.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3>188<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Responsive Website Developer | C Programmer | Database Developer | UI/UX Designer | Frontend Developer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Solve programming problems using flowcharts, pseudocode, and C constructs. Build responsive web applications with HTML5, CSS3, JavaScript, and ReactJS, leveraging AI for development and UI/UX design, Develop real-world solutions, gain foundational Generative AI skills for ethical innovation, and understand SQL Server architecture and core database components</p>
                </div>
            </div>
        </div>

    {/* Semester 2 */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 2</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester2.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3>170<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Java Application Programmer | C# Developer | AI-Ready Software Programmer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Design and develop OOP applicationss in Java, JavaFX, and C# with AI-assisted coding, version control (Git), and XML/JSON data handling, including low-code/no-code techniques. Gain foundational knowledge of OpenAI and SMAC technologies to architect modern software solutions</p>
                </div>
            </div>
        </div>

    {/* Semester 3a */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 3A (Java)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester3A.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3>170<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Exit:</span> Not Available</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Gain foundational Generative AI skills for creative, responsible, and future-ready innovation. Design and develop web components using AI-enhanced JSP, Servlets, and Spring based microservices. Build cross-platform mobile apps using Flutter and Dart with AI-assisted workflows, and apply Agile and DevOps practices supported by AI tools.</p>
                </div>
            </div>
        </div>

    {/* Semester 3b */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 3B (.net)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester3B.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3>150<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Exit:</span> Not Available</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Gain foundational Generative AI skills for creative, responsible, and future-ready innovation. Develop server-side web applications using AI-driven ASP.NET MVC, and build cross-platform apps with Flutter and Dart using AI-assisted workflows. Apply Agile and DevOps Methodologies supported by AI tools to deliver production ready solutions.</p>
                </div>
            </div>
        </div>

    {/* Semester 4a */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4A (Full Stack Development - OST & Java)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4A.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 230<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Python Web Application Developer |  Java Web Developer | Java Enterprise Application Developer | Cross-Platform App Developer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Use MySQL with AI capabilities and develop Python applications with Django/Flask and AI-assisted coding, and create enterprise solutions using Jakarta Enterprise Beans and AI-enabled web Services Implement CI/CD pipelines with Docker and Kubernetes, and design enhanced resource-planning and collaboration tools.</p>
                </div>
            </div>
        </div>

    {/* Semester 4b */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4B (Full Stack Development - OST & .NET)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4B.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 234<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Python Web Application Developer | .NET Web Application Developer | Cross-Platform App Developer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Use MySQL with AI capabilities and develop Python applications using modern AI libraries. Build AI-enabled web applications with Django/Flask and apply AI-assisted coding. Develop enterprise-grade .NET applications and Web Services on Microsoft Azure with AP APIs, and integrate Generative AI using Google Vertex AI. Implement build-test-deploy workflows with Docker and Kubernetes, and create enhanced resource planning and collaboration tools.</p>
                </div>
            </div>
        </div>

    {/* Semester 4c */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4C (OST & Oracle)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4C.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 242<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Python Web App Developer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Use MySQL with AI capabilities and develop Python applications using modern AI libraries. Build AI-enabled web applications with Django/Flask and apply AI-assisted coding. Gain skills in writing and optimizing SQL queries, creating secure PL/SQL programs, and managing Oracle databases, including installation, configuration, tuning, backup, security, and high availability.</p>
                </div>
            </div>
        </div>

    {/* Semester 4d */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4D (Networking & Ethical Hacking)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4D.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 278<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Microsoft Azure Administrator | Azure Solutions Architect | Cloud Administration | Ethical Hacker</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Develop secure networking capabilities, including network setup, maintenance, and cybersecurity fundamentals, along with authorized penetration testing techniques. Design, deploy, and monitor AI workloads and scalable architectures on Azure using services like Azure ML and Azure OpenAI. Build and manage hybrid on-premise environments while enforcing security policies and intrusion-detection practices.</p>
                </div>
            </div>
        </div>

    {/* Semester 4e */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4E (AI & ML)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4E.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 288<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> AI & ML Developer | NLP Developer | AI Agent Developer | ML Engineer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Gain strong foundation in statistics, Python programming, and data analysis, including Pandas, visualization, and Flask-based development. Master core and advanced AI/ML concepts, supervised/unsupervised learning, deep learning with TensorFlow, NLP with LLMs, and RAG, and computer vision to build and evaluate intelligent models. Develop applied AI solutions such as Recommendations systems and churn predictions, and explore cutting edge architectures including transformers, AI agents, and quantum ML.</p>
                </div>
            </div>
        </div>

    {/* Semester 4f */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4F (Data Science)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4F.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 288<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> Data Analyst | AI-Powered MongoDB Developer | MLOps Specialist | Reinforcement Learning Specialist | Power BI Developer</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span> Design scalable MongoDB data models for large unstructured/semi-structured datasets and create interactive analytics dashboards using Power BI. Build Python-based data solutions with Pandas, Matplotlib/Seaborn, Flask, and advanced ML techniques - including ANN, CNN, RNN, and reinforcement learning to perform predictive and descriptive analytics. Implement end-to-end ML pipelines, deploy models via Flask, and apply AI-driven forecasting for real-world scenarios such as currency prediction and data lake architecture.</p>
                </div>
            </div>
        </div>

{/* Semester 4g */}
        <header className={style.courseHeader}>
            <h2 className={style.courseTitle}>Semester 4G (Internet of Things)</h2>
        </header>
        <div className={style.courseRow}>
            <ul className={style.listRow}>
                {semester4G.map((course, index) => (
                    <li key={index}>{course}</li>
                ))}
            </ul>
            <div className={style.courseDuration}>
                <div className={style.courseHours}>
                    <span>Duration : </span>
                    <h3> 216<br />Hours</h3>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Job Opportunities:</span> IoT Developer | Python Developer for IoT Applications</p>
                </div>
                <div className={style.courseOpportunities}>
                    <p><span>Learning Outcomes:</span>Develop AI-enhanced Python applications abnd build intelligent IoT systems capable of autonomous sensing, processing, and decision-making. Apply secure networking protocols, advanced IoT architectures, and Python-based automation to design, deploy, and integrate hardware-software solutions. Deliver real-world IoT applications by combining AI, connectivity, and embedded technologies.</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Course